let map;

async function initMap() 
{  
  const boutiqueCoordinates = { lat: 45.42114, lng: -75.70114 }; // Coordinates for Howard Fine Jewellers at 220 Sparks Street

  // Map

  //@ts-ignore
  const { Map } = await google.maps.importLibrary("maps");

  var mapOptions = {
                    zoom: 16,
                    center: boutiqueCoordinates,
                    scrollwheel: false,
                    disableDoubleClickZoom: true,
                    disableDefaultUI: true,
                    zoomControl: false,
                    styles: [{ "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }] }, { "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, {"elementType":"labels.text.fill", "stylers": [{ "color": "#616161" }] }, { "elementType": "labels.text.stroke", "stylers": [{ "color": "#f5f5f5" }] }, {"featureType":"administrative.land_parcel", "elementType": "labels.text.fill", "stylers": [{ "color": "#bdbdbd" }] }, { "featureType": "poi", "elementType":"geometry", "stylers":[{ "color": "#eeeeee" }] }, { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [{ "color": "#757575" }] }, {"featureType":"poi.park","elementType": "geometry", "stylers": [{ "color": "#d2dfd6" }] }, {"featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{ "color":"#9e9e9e" }]}, { "featureType": "road", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }] }, { "featureType": "road.arterial", "elementType": "labels.text.fill","stylers": [{ "color": "#757575" }] }, { "featureType": "road.highway", "elementType": "geometry", "stylers": [{ "color": "#dadada" }] }, {"featureType":"road.highway", "elementType": "labels.text.fill", "stylers": [{ "color": "#616161" }] }, { "featureType": "road.local", "elementType": "labels.text.fill","stylers": [{ "color": "#9e9e9e" }] }, { "featureType": "transit.line", "elementType": "geometry", "stylers": [{ "color": "#e5e5e5" }] }, {"featureType":"transit.station", "elementType": "geometry", "stylers": [{ "color": "#eeeeee" }] }, { "featureType": "water", "elementType": "geometry", "stylers": [{"color":"#ced8dd" }] }, { "featureType": "water", "elementType": "labels.text.fill", "stylers": [{ "color": "#c9c9c9" }] }, { "featureType": "water", "elementType":"all","stylers": [{ "lightness": -20 }] }, { "featureType": "water", "elementType": "geometry.fill", "stylers": [{ "visibility": "on" }, { "color": "#ced8dd" }] }, {"featureType": "water", "elementType": "labels.text", "stylers": [{ "visibility": "simplified" }] }],
                };

  var mapElement = document.getElementById('map');
  var map = new google.maps.Map(mapElement, mapOptions);

  
  // Markers
  
  const hfjPin = {
    url: "https://cdn.shopify.com/s/files/1/0287/3432/4784/files/hfj-map-location-pin.svg",
    scaledSize: new google.maps.Size(50, 50),
  };

  var marker = new google.maps.Marker({
                map: map,
                position: boutiqueCoordinates,
                clickable: false,
                icon: hfjPin,
            });

  var hillPin = {
                path: 'M 25, 50 a 25,25 0 1,1 50,0 a 25,25 0 1,1 -50,0',
                strokeColor: '#FFF',
                strokeWeight: 1,
                fillColor: '#000',
                fillOpacity: 1,
                scale: 0.001,
            };

  var hill = new google.maps.Marker({
                map: map,
                position: { lat: 45.42515, lng: -75.6999 }, 
                clickable: false,
                title: "Parliament Hill",
                icon: hillPin,
                label: { color: '#9E9E9E', fontWeight: 'normal', fontSize: '14px', text: 'Parliament Hill', className: 'subdued-map-text-border', },
            });


  // Custom Zoom Controls

  function CustomZoomInControl(controlDiv, map) 
  {
    controlDiv.classList.add("top-margin-10");
    
    var controlUI = document.createElement('div');
    controlUI.classList.add("map-zoom-control");
    controlDiv.appendChild(controlUI);

    var controlText = document.createElement('div');
    controlText.classList.add("map-zoom-icon");
    controlText.innerHTML = '+';
    controlUI.appendChild(controlText);

    google.maps.event.addDomListener(controlUI, 'click', function () {
        map.setZoom(Math.min(map.getZoom() + 1, 18));
    });
  }

  function CustomZoomOutControl(controlDiv, map) 
  {
    var zoomOutControl = document.createElement('div');
    zoomOutControl.classList.add("map-zoom-control");
    controlDiv.appendChild(zoomOutControl);

    var zoomOutControlText = document.createElement('div');
    zoomOutControlText.classList.add("map-zoom-icon");
    zoomOutControlText.innerHTML = '–';
    zoomOutControl.appendChild(zoomOutControlText);

    google.maps.event.addDomListener(zoomOutControl, 'click', function () {
        map.setZoom(Math.max(map.getZoom() - 1, 2));
    });
  }
  
  // Create a layer to hold each zoom control and add them to the map
  var customZoomInControlDiv = document.createElement('div');
  var customZoomInControl = new CustomZoomInControl(customZoomInControlDiv, map);
  customZoomInControlDiv.index = 1;
  map.controls[google.maps.ControlPosition.TOP_RIGHT].push(customZoomInControlDiv);
  
  var customZoomOutControlDiv = document.createElement('div');
  var customZoomOutControl = new CustomZoomOutControl(customZoomInControlDiv, map);
  customZoomOutControlDiv.index = 1;
  map.controls[google.maps.ControlPosition.TOP_RIGHT].push(customZoomOutControlDiv);  

  // Hide Parliament Hill pin when zoomed out
  google.maps.event.addListener(map, 'zoom_changed', function() 
  {
      var zoom = map.getZoom();
      hill.setVisible(zoom > 13);
  });
}

initMap();